import { Component } from '@angular/core';

import { TreasuryService } from '../../core/treasury.service';

/** A selectable Bordereau division on the landing page. */
interface Division {
  key: 'actuary' | 'finance';
  name: string;
  description: string;
  /** PrimeIcon class. */
  icon: string;
  /** Number of reports available under the division. */
  reportCount: number;
  /** Router path the card navigates to. */
  route: string;
  /** Accent colour for the card. */
  color: string;
}

/**
 * Landing page. The user picks a division (Actuary or Finance) and is taken to
 * that division's reports hub.
 */
@Component({
  selector: 'app-division-landing',
  standalone: false,
  templateUrl: './division-landing.component.html',
  styleUrl: './division-landing.component.scss'
})
export class DivisionLandingComponent {
  readonly divisions: Division[] = [
    {
      key: 'actuary',
      name: 'Actuary',
      description:
        'Summary, expected outcomes, OC/QCE composite ratios and by-fund projections used for pricing and reserving.',
      icon: 'pi pi-chart-line',
      reportCount: 4,
      route: '/actuary',
      color: '#0E7C86'
    },
    {
      key: 'finance',
      name: 'Finance',
      description:
        'Balance sheet, collected/paid, journal & investment entries, trial balance, reconciliations, quarterly close/segment entries and SOP.',
      icon: 'pi pi-wallet',
      reportCount: 18,
      route: '/finance',
      color: '#1F5C8B'
    }
  ];

  constructor(readonly treasury: TreasuryService) {}
}
